/** Waiting for the API. Keeps the layout height so the page does not jump. */
export interface LoadingStateProps {
  /** What is being fetched, e.g. "Loading the pipeline". */
  label?: string;
  /** Number of skeleton rows to draw. Zero renders the label alone. */
  rows?: number;
  /** Tightens the padding, for a panel inside a card. */
  compact?: boolean;
  className?: string;
}

export function LoadingState({
  label = 'Loading',
  rows = 3,
  compact = false,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={['loading-state', compact ? 'loading-compact' : '', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      <span className="loading-label">
        <span className="spinner" aria-hidden="true" />
        {label}
      </span>
      {rows > 0 && (
        <div className="skeletons" aria-hidden="true">
          {Array.from({ length: rows }, (_, i) => (
            <span key={i} className="skeleton" style={{ width: `${92 - i * 11}%` }} />
          ))}
        </div>
      )}
    </div>
  );
}

export default LoadingState;
